module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.job.status.details_path) ? _c('a', {
    ref: "tooltip",
    class: _vm.cssClassJobName,
    attrs: {
      "href": _vm.job.status.details_path,
      "title": _vm.tooltipText,
      "data-toggle": "tooltip",
      "data-container": "body"
    }
  }, [_c('job-name-component', {
    attrs: {
      "name": _vm.job.name,
      "status": _vm.job.status
    }
  })], 1) : _c('div', {
    ref: "tooltip",
    class: _vm.cssClassJobName,
    attrs: {
      "title": _vm.tooltipText,
      "data-toggle": "tooltip",
      "data-container": "body"
    }
  }, [_c('job-name-component', {
    attrs: {
      "name": _vm.job.name,
      "status": _vm.job.status
    }
  })], 1), _vm._v(" "), (_vm.hasAction && !_vm.isDropdown) ? _c('action-component', {
    attrs: {
      "tooltip-text": _vm.job.status.action.title,
      "link": _vm.job.status.action.path,
      "action-icon": _vm.job.status.action.icon,
      "action-method": _vm.job.status.action.method
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasAction && _vm.isDropdown) ? _c('dropdown-action-component', {
    attrs: {
      "tooltip-text": _vm.job.status.action.title,
      "link": _vm.job.status.action.path,
      "action-icon": _vm.job.status.action.icon,
      "action-method": _vm.job.status.action.method
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/git/gitlab/~/vue-loader/lib/template-compiler?{"id":"data-v-49d279d4"}!/home/git/gitlab/~/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/graph/job_component.vue
// module id = pIwE
// module chunks = 6